import React from "react";
import { first, last, next, previous, processJump } from "../js/sliderUtils";

const TimeSliderControls = ({
    fhour,
    setFhour,
    inputValue,
    setInputValue,
    play,
    setPlay,
    timeZone,
    setTimeZone,
    timeZoneOptions,
    initstr,
    timing,
    validstr,
    timeMinimized,
    toggleMinimizeTime,
}) => {

    const handleJump = (event) => {
        const { value } = event.target;
        setInputValue(value);

        if (event.type === "keyup" && event.key === "Enter") {
            processJump(event, setFhour);
        } else if (event.type === "blur") {
            processJump(event, setFhour);
        }
    };

    return (
        <div className="time-bar">
            {!timeMinimized && (
                <div className="time-bar-content">
                    {/* Row 1: Slider */}
                    <div className="time-slider-row">
                        <div id="timeslider"></div>
                    </div>

                    {/* Row 2: Playback + Time Info + Timezone */}
                    <div className="time-controls-row">
                        <div className="playback-group">
                            <button className="transport-btn" id="first" onClick={() => first(fhour, setFhour)}>
                                <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><rect x="1" y="2" width="2" height="12"/><path d="M14 2L5 8l9 6z"/></svg>
                            </button>
                            <button className="transport-btn" id="previous" onClick={() => previous(fhour, setFhour)}>
                                <svg width="10" height="12" viewBox="0 0 10 16" fill="currentColor"><path d="M10 0L0 8l10 8z"/></svg>
                            </button>
                            <button className="play-btn" id="play-pause" onClick={() => setPlay(!play)}>
                                {play ? (
                                    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><rect x="2" y="1" width="4" height="14"/><rect x="10" y="1" width="4" height="14"/></svg>
                                ) : (
                                    <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><path d="M3 1l12 7-12 7z"/></svg>
                                )}
                            </button>
                            <button className="transport-btn" id="next" onClick={() => next(fhour, setFhour)}>
                                <svg width="10" height="12" viewBox="0 0 10 16" fill="currentColor"><path d="M0 0l10 8-10 8z"/></svg>
                            </button>
                            <button className="transport-btn" id="last" onClick={() => last(fhour, setFhour)}>
                                <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor"><path d="M2 2l9 6-9 6z"/><rect x="13" y="2" width="2" height="12"/></svg>
                            </button>
                        </div>

                        <div className="forecast-hour-group">
                            <span className="fhour-label">F</span>
                            <input
                                type="text"
                                className="fhour-input"
                                id="jumpinput"
                                name="jumpinput"
                                onChange={(e) => setInputValue(e.target.value)}
                                onKeyUp={handleJump}
                                onBlur={handleJump}
                                value={inputValue}
                            />
                        </div>

                        <div className="time-info-group">
                            <div className="time-info-row">
                                <span className="time-label">Init</span>
                                <span className="time-value">{initstr}</span>
                            </div>
                            <div className="time-info-row">
                                <span className="time-label">Valid</span>
                                <span className="time-value">{validstr}</span>
                            </div>
                        </div>

                        <select
                            className="tz-select"
                            id="timezone-select"
                            value={timeZone}
                            onChange={(e) => setTimeZone(e.target.value)}
                        >
                            {timeZoneOptions}
                        </select>
                    </div>
                </div>
            )}
            <div className="time-bar-toggle" onClick={toggleMinimizeTime}>
                <span className={`toggle-chevron ${timeMinimized ? "down" : "up"}`} />
            </div>
        </div>
    );
};

export default TimeSliderControls;
